// components/WhoWeAreSection.jsx
import React from "react";
import "./WhoWeAreSection.css";

import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";

function WhoWeAreSection() {
  return (
    <section className="section who-are-section" id='about'>
      <div className="section-inner">

        <div className="section-header section-header-center fade-up">
          {/* <p className="section-kicker">Who We Are</p> */}
          <h2 className="section-title who-title-lg">About us</h2>
          <p className="section-subtitle who-sub-lg">
          
          </p>
        </div>

        <div className="who-we-are-banner fade-in">
          <div className="who-we-are-left slide-in">
            <p className="who-we-are-text who-text-lg">
                Tawaf is a US-based company led by mission-driven scholars, engineers,
            and pilgrimage service experts who have seen the pain points up close:
            elders getting lost, first-time pilgrims unsure if they’re “doing it right,”
            and families struggling to stay together.
              We built Tawaf to remove those worries. By combining real-world pilgrim
              experience with thoughtful technology, we want every pilgrim — especially
              the non–tech-savvy and first-timers — to feel guided, safe, and understood.
            </p>

            <p className="who-we-are-text who-text-lg">
              Our mission is simple: to give every pilgrim clarity, confidence, and
              connection, so their heart can stay focused on worship.
            </p>

            <p className="who-we-are-text highlight-text">
              Designed with safety, privacy, and respect.
            </p>

            <p className="who-we-are-text who-text-lg">
              Tawaf is built with deep care for both your journey and your data. We’re
              committed to culturally sensitive guidance, and we design our systems so
              your information, identity, and location stay protected and in your control.
            </p>

            <div className="who-we-are-pillars fade-up-delayed">
              <div className="pillar-pill">
                <ShieldRoundedIcon fontSize="small" />
                <span>Safety</span>
              </div>

              <div className="pillar-pill">
                <LockRoundedIcon fontSize="small" />
                <span>Privacy</span>
              </div>

              <div className="pillar-pill">
                <FavoriteRoundedIcon fontSize="small" />
                <span>Respect</span>
              </div>
            </div>
          </div>

          <div className="who-we-are-image-wrap zoom-in">
            <div className="who-we-are-image" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhoWeAreSection;
